import React from 'react';
import { post, get } from '../../custom_libraries/serverRequests';
import globalVariables from '../../custom_libraries/globalVariables';
import urls from '../../custom_libraries/urls';
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";
import Backdrop from '@mui/material/Backdrop';
import WebLogo from '../../assets/Artboard 1Bonus.png';
import './TrueThreatSmsSettings.css';
import { Button} from '@mui/material';

class SmsNotificationSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      enabled: false,
      phoneNumber: [],
      country_code_1: "+91",
      country_code_2: "+91",
      country_code_3: "+91",
      mob_no_1: '',
      mob_no_2: '',
      mob_no_3: '',
      response_message: '',
      error2: false,
      success: false,
      open_progress_bar: false,
    };
  }

  componentDidMount() {
    this.fetchUserSettings();
  }

  handleToggle = () => {
    this.setState((prevState) => ({ enabled: !prevState.enabled }));
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  startLoading = () => {
    this.setState({ open_progress_bar: true})
  }
  
  stopLoading = () => {
      this.setState({ open_progress_bar: false})
  }

  handleSubmit = async(event) => {
    event.preventDefault();
    const { mob_no_1, mob_no_2, mob_no_3, country_code_1, country_code_2, country_code_3} = this.state;
    console.log('SMS notification settings saved:', { mob_no_1, mob_no_2, mob_no_3 });
    const phoneNumber = [mob_no_1, mob_no_2, mob_no_3];
    try{
     //  Check if any phone number is empty or invalid --> modified the condition below to allow blank custom field while saving as it was not allowing to update other info. if any custom field kept blank
      for (let i = 0; i < phoneNumber.length; i++) {
        const phone = phoneNumber[i].trim();

        if (phone && !/^\d{10}$/.test(phone)) {
          this.setState({
            error2: true,
            response_message: `Invalid phone number at position ${i + 1}. It must be a 10-digit number.`,
          });
          setTimeout(() => {
            this.setState({ error2: false, response_message: "" });
          }, 3000);
          return;
        }
      }
    
        // Remove blank values
        const filteredPhoneNo = phoneNumber
          .map(phone => phone.trim())
          .filter(phone => phone !== "");

        // Update UI
        this.setState({ phoneNumber: filteredPhoneNo });

        // Convert to API format
        let post_data = {
          contact_numbers: filteredPhoneNo.map(phone => ({
            contact_number: phone,
            country_code: phone === mob_no_1 ? country_code_1 : phone === mob_no_2 ? country_code_2 : country_code_3
          })),
        };
    
        post_data= JSON.stringify(post_data);
        console.log("post data===>", post_data);
      
        this.startLoading();
      
        let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
        let headers = {
          'content-type': 'application/json',
          'Authorization': `Bearer ${access_token}`
        };
      
        let response = await post(urls.TRUE_THREAT_SMS_NOTIFICATIONS_SETTING, post_data, headers);
        console.log("handleSave response===>", response);
        this.stopLoading();
      
        if(response?.success === true){
          this.setState({success: true});
        } else if (response.success === false) {
          this.setState({ error2: true, response_message: response.message });
        } 
         else {
          this.setState({ error2: true, response_message: response.message || "An error occurred while saving the settings." });
        }
        setTimeout(() => {
          this.setState({ success: false, error2: false, response_message: "" });
          this.fetchUserSettings(); // Refetch the settings after saving
        }, 5000);
    } catch (error) {
      console.error("Error saving SMS notification settings:", error);
      this.setState({ error2: true });
    }
  };

    fetchUserSettings = async() => {
    const { mob_no_1, mob_no_2, mob_no_3} = this.state;
    try{
      
        this.startLoading();
      
        let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
        let headers = {
          'content-type': 'application/json',
          'Authorization': `Bearer ${access_token}`
        };
      
        let response = await get(urls.TRUE_THREAT_SMS_NOTIFICATIONS_SETTING, headers);
        console.log("fetchUserSettings response===>", response);
        this.stopLoading();
        const contacts = response?.data || [];
      
        if(response?.success === true){
          this.setState({
            mob_no_1: contacts[0]?.contact_number || "",
            mob_no_2: contacts[1]?.contact_number || "",
            mob_no_3: contacts[2]?.contact_number || "",
            country_code_1: contacts[0]?.country_code || "+91",
            country_code_2: contacts[1]?.country_code || "+91",
            country_code_3: contacts[2]?.country_code || "+91",

            id_1: contacts[0]?.id || null,
            id_2: contacts[1]?.id || null,
            id_3: contacts[2]?.id || null,
          });
        } else if (response.success === false) {
          this.setState({ error2: true, response_message: response.message });
        } 
         else {
          this.setState({ error2: true, response_message: response.message || "An error occurred while saving the settings." });
        }
    } catch (error) {
      console.error("Error saving SMS notification settings:", error);
      this.setState({ error2: true });
    }
  };

  render() {
    const { mob_no_1, mob_no_2, mob_no_3, error2, warning, success, response_message } = this.state;

    return (
      <div className="true-threat-sms-page">

      <div className="side-by-side-container true-threat-sms-layout" style={{ flex: '2', marginLeft:'5%', padding: '20px', overflowY: 'auto', gap:'20px', width:'90%' }}>
        <div className="health-setting-container true-threat-sms-settings" style={{width:'50%'}}>
          <div>
            { error2 ? (
                <Alert severity="error">{response_message}</Alert>
            ) : success ? (
                <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                    "Settings saved successfully."
              </Alert>
            ) : null}
          </div>
            <h3 style={{textAlign: "center"}}>SMS Notification Settings for True Threat Alerts</h3>
            <form className="true-threat-sms-form" onSubmit={this.handleSubmit} style={{marginTop: "25px"}}>
            <div className="true-threat-phone-row" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <label>
                <span className="true-threat-phone-label">Phone Number 1 :</span>&nbsp;
                <span className="true-threat-phone-controls">
                <select
                  aria-label="Country code for phone number 1"
                  name="country_code_1"
                  value={this.state.country_code_1}
                  onChange={this.handleChange}
                  style={{
                    width: '100px',
                    height: '28px',
                    padding: '0 5px',
                    border: "1px solid #ccc",
                    backgroundColor: "#353d4f",
                    color: "white",
                    borderRadius: "4px"
                  }}
                >
                    <option value="+91">+91 (IN)</option>
                    <option value="+1">+1 (US/CA)</option>
                    <option value="+44">+44 (UK)</option>
                    <option value="+61">+61 (AU)</option>
                </select>&nbsp;
                <input
                    type="tel"
                    className="sms-input"
                    name="mob_no_1"
                    value={mob_no_1}
                    onChange={this.handleChange}
                    aria-label="Phone number 1"
                />
                </span>
                </label>
            </div><br/>
            <div className="true-threat-phone-row" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <label>
                <span className="true-threat-phone-label">Phone Number 2 :</span>&nbsp;
                <span className="true-threat-phone-controls">
                <select
                  aria-label="Country code for phone number 2"
                  name="country_code_2"
                  value={this.state.country_code_2}
                  onChange={this.handleChange}
                  style={{
                    width: '100px',
                    height: '28px',
                    padding: '0 5px',
                    border: "1px solid #ccc",
                    backgroundColor: "#353d4f",
                    color: "white",
                    borderRadius: "4px"
                  }}
                >
                  <option value="+91">+91 (IN)</option>
                  <option value="+1">+1 (US/CA)</option>
                  <option value="+44">+44 (UK)</option>
                  <option value="+61">+61 (AU)</option>
                </select>&nbsp;
                <input
                    type="tel"
                    className="sms-input"
                    name="mob_no_2"
                    value={mob_no_2}
                    onChange={this.handleChange}
                    aria-label="Phone number 2"
                />
                </span>
                </label>
            </div><br/>
            <div className="true-threat-phone-row" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <label>
                <span className="true-threat-phone-label">Phone Number 3 :</span>&nbsp;
                <span className="true-threat-phone-controls">
                <select
                  aria-label="Country code for phone number 3"
                  name="country_code_3"
                  value={this.state.country_code_3}
                  onChange={this.handleChange}
                  style={{
                    width: '100px',
                    height: '28px',
                    padding: '0 5px',
                    border: "1px solid #ccc",
                    backgroundColor: "#353d4f",
                    color: "white",
                    borderRadius: "4px"
                  }}
                >
                  <option value="+91">+91 (IN)</option>
                  <option value="+1">+1 (US/CA)</option>
                  <option value="+44">+44 (UK)</option>
                  <option value="+61">+61 (AU)</option>
                </select>&nbsp;
                <input
                    type="tel"
                    className="sms-input"
                    name="mob_no_3"
                    value={mob_no_3}
                    onChange={this.handleChange}
                    aria-label="Phone number 3"
                />
                </span>
                </label>
            </div><br/>

            <Button 
                type="submit" 
                id="rowsPerPageButton"
                // style={{
                //     minWidth: "25px",
                //     height: "31px",
                // }}
            >
                Save
            </Button>
            </form>
        </div>
        <div className="true-threat-sms-help" style={{width:'50%'}}>
            <div className="form-section" style={{fontFamily: "Arial, sans-serif", width:'100%'}} >
                
                
                <h4>How it works?</h4>
                <p style={{ fontSize: "15px", marginBottom: "7px", textAlign: "justify" }}>
                <span style={{color:'lightseagreen'}}>Mobile numbers for sms delivery</span> <br/><br/>
                <strong>-</strong> Please specify the country code and mobile numbers to receive the sms about the 'True threat alerts' detected while video anaysis.
                <br />
                <strong>-</strong> You can specify upto three mobile numbers to receive the sms about the threat alerts<br />
                
                </p>
            </div>
        </div>
      </div>
      {/* Backdrop with Circular Progress */}
                <Backdrop open={this.state.open_progress_bar}>
                  <div className="custom-spinner">
                      <div className="circle"></div>
                      <div className="circle tilted"></div>
                      <img src={this.state.storedLogo ? this.state.storedLogo : WebLogo} alt="web-logo" style={{backgroundColor:'#001f54', borderRadius:'100px'}}/>
                  </div>
                </Backdrop>
      </div>
    );
  }
}

export default SmsNotificationSettings;
